import React, { useEffect, useState } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";

const Home = () => {
  const navigate = useNavigate();

  const [recentActivity, setRecentActivity] = useState({});
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    totalRegistered: 0,
    feesPaid: 0,
    pendingFees: 0,
    totalPendingAmount: 0,
  });

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("userToken");
      const res = await axios.get(`${BaseUrl}/api/reg/count`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (res && res.data) {
        setDashboardData(res.data);
      }
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("userToken");
    if (!token) {
      navigate("/login");
      return;
    }
    fetchDashboardData();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <h3 className="text-center text-uppercase text-success" style={{ fontWeight: "500" }}>
            Dashboard
          </h3>
          <div className="row">
            <div className="col-md-3">
              <div className="stat-card">
                <h3>Total Students Registered</h3>
                <p>{dashboardData.totalRegistered}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <h3>Students with Fees Paid</h3>
                <p>{dashboardData.feesPaid}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <h3>Students with Pending Fees</h3>
                <p>{dashboardData.pendingFees}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <h3>Total Pending Fees to be Paid</h3>
                <p>{dashboardData.totalPendingAmount}</p>
              </div>
            </div>
          </div>

          <div className="recent-activity mt-2">
            <h2 className="text-center text-uppercase text-success" style={{ fontWeight: "500" }}>
              Recent<span style={{ color: "#20e61b" }}> Activity</span>
            </h2>
            <hr />
            {recentActivity.length ? (
              <div className="timeline-container">
                {/* Existing static recent activity cards */}
                <div className="timeline-date-group">
                  <div className="timeline-indicator">
                    <div className="timeline-dot"></div>
                    <div className="timeline-line"></div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-date">
                      <h5>05/02/2025</h5>
                    </div>
                    <div className="timeline-tasks">
                      <div className="timeline-card">
                        <p className="timeline-card-action">
                          <strong>Image</strong> Uploaded by <strong>Admin</strong> in gallery.
                        </p>
                        <div className="timeline-card-footer float-right">
                          <span className="timeline-card-date">05/02/2025 01:15:34 pm</span>
                          <span className="timeline-card-assignee new">New</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="timeline-date-group">
                  <div className="timeline-indicator">
                    <div className="timeline-dot"></div>
                    <div className="timeline-line"></div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-date">
                      <h5>03/02/2025</h5>
                    </div>
                    <div className="timeline-tasks">
                      <div className="timeline-card">
                        <p className="timeline-card-action">
                          <strong>Notification</strong> Updated by <strong>Admin</strong> in Home Page.
                        </p>
                        <div className="timeline-card-footer float-right">
                          <span className="timeline-card-date">03/02/2025 12:15:34 pm</span>
                          <span className="timeline-card-assignee update">Update</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="timeline-date-group">
                  <div className="timeline-indicator">
                    <div className="timeline-dot"></div>
                    <div className="timeline-line"></div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-date">
                      <h5>01/02/2025</h5>
                    </div>
                    <div className="timeline-tasks">
                      <div className="timeline-card">
                        <p className="timeline-card-action">
                          <strong>Link</strong> Deleted by <strong>Admin</strong> in Home Page.
                        </p>
                        <div className="timeline-card-footer float-right">
                          <span className="timeline-card-date">01/02/2025 12:15:34 pm</span>
                          <span className="timeline-card-assignee deleted">Delete</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p>No recent activity</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
